createNotFoundModel